export const settings = [
  {
    id: 'scadrial-canal-district',
    world: 'scadrial',
    name: 'an industrial canal district',
    atmosphere:
      'Canal traffic has locked together between tall warehouses, and every iron railing carries the vibration of hurried footsteps.',
    tags: ['urban', 'crowd', 'water', 'metal'],
  },
  {
    id: 'scadrial-rail-station',
    world: 'scadrial',
    name: 'a crowded rail station',
    atmosphere:
      'Steam, luggage, and impatient travelers fill the platforms while an incoming train sounds its warning horn.',
    tags: ['urban', 'crowd', 'machinery', 'travel'],
  },
  {
    id: 'scadrial-roughs-town',
    world: 'scadrial',
    name: 'a remote town in the Roughs',
    atmosphere:
      'The nearest help is hours away, the main street is nearly empty, and everyone is watching from behind shuttered windows.',
    tags: ['frontier', 'isolated', 'law', 'dust'],
  },
  {
    id: 'scadrial-noble-estate',
    world: 'scadrial',
    name: 'a noble estate during a formal gathering',
    atmosphere:
      'Music and polite conversation cover a current of private alliances, concealed weapons, and carefully managed emotion.',
    tags: ['social', 'political', 'crowd', 'enclosed'],
  },
  {
    id: 'scadrial-flooded-mine',
    world: 'scadrial',
    name: 'a flooded metal mine',
    atmosphere:
      'Cold water climbs through narrow shafts as old supports complain beneath the weight of the rock above.',
    tags: ['underground', 'water', 'trapped', 'metal'],
  },
  {
    id: 'scadrial-metalworks',
    world: 'scadrial',
    name: 'a sprawling metalworks factory',
    atmosphere:
      'Furnaces throw harsh light across moving machinery, suspended loads, and catwalks crowded with workers.',
    tags: ['industrial', 'fire', 'machinery', 'metal'],
  },
  {
    id: 'scadrial-terris-enclave',
    world: 'scadrial',
    name: 'a secluded Terris enclave',
    atmosphere:
      'Mountain weather closes in around a community built on trust, scholarship, and traditions outsiders rarely understand.',
    tags: ['community', 'mountain', 'tradition', 'isolated'],
  },
  {
    id: 'scadrial-ash-plain',
    world: 'scadrial',
    name: 'an ash-covered plain',
    atmosphere:
      'Visibility falls by the minute as wind drives ash across the road and erases every useful landmark.',
    tags: ['wilderness', 'ash', 'exposure', 'travel'],
  },
  {
    id: 'scadrial-cavern-complex',
    world: 'scadrial',
    name: 'an ancient cavern complex',
    atmosphere:
      'Metal fixtures mark routes through chambers whose original purpose has been forgotten, and several passages have recently shifted.',
    tags: ['underground', 'ancient', 'mystery', 'unstable'],
  },
  {
    id: 'scadrial-airship-dock',
    world: 'scadrial',
    name: 'a Southern Scadrian airship dock',
    atmosphere:
      'Crews race between mooring lines and unfamiliar machinery while the dock sways high above the ground.',
    tags: ['height', 'machinery', 'travel', 'crowd'],
  },
  {
    id: 'roshar-warcamp-market',
    world: 'roshar',
    name: 'a warcamp marketplace',
    atmosphere:
      'Merchants, soldiers, and refugees press through narrow lanes while distant horns repeatedly interrupt the bargaining.',
    tags: ['crowd', 'military', 'urban', 'political'],
  },
  {
    id: 'roshar-highstorm-shelter',
    world: 'roshar',
    name: 'an overcrowded highstorm shelter',
    atmosphere:
      'The stormwall has arrived early, shutters are failing, and frightened strangers have nowhere else to go.',
    tags: ['storm', 'enclosed', 'crowd', 'survival'],
  },
  {
    id: 'roshar-shattered-chasm',
    world: 'roshar',
    name: 'a chasm on the Shattered Plains',
    atmosphere:
      'Water begins to rise between sheer stone walls while movement above sends debris falling into the narrow passage.',
    tags: ['wilderness', 'height', 'water', 'isolated'],
  },
  {
    id: 'roshar-urithiru',
    world: 'roshar',
    name: 'a busy corridor in Urithiru',
    atmosphere:
      'Messages, supplies, and people from rival nations converge inside a tower where every decision carries political weight.',
    tags: ['urban', 'political', 'crowd', 'tower'],
  },
  {
    id: 'roshar-stone-caravan',
    world: 'roshar',
    name: 'a caravan crossing open stone',
    atmosphere:
      'The nearest shelter is a distant line on the horizon, and the caravan has begun leaving supplies behind to maintain its pace.',
    tags: ['travel', 'wilderness', 'exposure', 'resource'],
  },
  {
    id: 'roshar-coastal-port',
    world: 'roshar',
    name: 'a Rosharan coastal port',
    atmosphere:
      'Ships strain against their lines as waves climb the seawall and dockworkers attempt to clear the waterfront.',
    tags: ['water', 'storm', 'crowd', 'travel'],
  },
  {
    id: 'roshar-oathgate',
    world: 'roshar',
    name: 'an active Oathgate platform',
    atmosphere:
      'Travelers wait inside the control building while conflicting orders arrive from both sides of the gate.',
    tags: ['travel', 'magical', 'crowd', 'political'],
  },
  {
    id: 'roshar-gemstone-mine',
    world: 'roshar',
    name: 'a deep gemstone mine',
    atmosphere:
      'A damaged lift has stranded workers below, and spheres provide less light with every passing minute.',
    tags: ['underground', 'resource', 'trapped', 'darkness'],
  },
  {
    id: 'roshar-ancient-ruin',
    world: 'roshar',
    name: 'a storm-worn ancient ruin',
    atmosphere:
      'Half-buried carvings suggest the site is important, but recent tracks prove your party is not the first to reach it.',
    tags: ['ancient', 'mystery', 'wilderness', 'storm'],
  },
  {
    id: 'roshar-shadesmar-dock',
    world: 'roshar',
    name: 'a small Shadesmar trading dock',
    atmosphere:
      'Beads shift like a black sea around the platform while unfamiliar spren watch every exchange with exacting attention.',
    tags: ['realmatic', 'travel', 'strange', 'social'],
  },
];

export const challenges = [
  {
    id: 'failing-structure',
    title: 'The Structure Gives Way',
    preferredTags: ['strength', 'speed', 'structure', 'flight', 'rescue', 'force'],
    tones: ['tactical', 'moral'],
    problem:
      'A crowded structure begins to collapse just as the person responsible is spotted escaping with evidence of a larger plot.',
    optionA: 'commit your power to rescuing the people in immediate danger',
    optionB: 'pursue the saboteur before the wider threat disappears with them',
  },
  {
    id: 'vanishing-target',
    title: 'A Narrow Window',
    preferredTags: ['speed', 'flight', 'detection', 'foresight', 'travel', 'pursuit'],
    tones: ['tactical', 'chaotic'],
    problem:
      'A courier carrying dangerous information breaks from the crowd while their associates create several convincing escape routes.',
    optionA: 'chase the courier immediately with incomplete information',
    optionB: 'stop to identify the real destination and risk losing the trail',
  },
  {
    id: 'missing-vulnerable-person',
    title: 'Someone Is Missing',
    preferredTags: ['senses', 'detection', 'memory', 'connection', 'healing', 'tracking'],
    tones: ['moral', 'balanced'],
    problem:
      'A vulnerable person has vanished during the confusion, and two witnesses give mutually exclusive accounts of where they went.',
    optionA: 'trust the evidence that points toward the greatest physical danger',
    optionB: 'follow the less likely account because the witness seems genuinely afraid',
  },
  {
    id: 'hidden-sabotage',
    title: 'The Failure Was Deliberate',
    preferredTags: ['detection', 'knowledge', 'stealth', 'matter', 'intellect', 'metal'],
    tones: ['tactical', 'balanced'],
    problem:
      'Critical equipment fails in a way that looks accidental, but one small inconsistency suggests deliberate sabotage from inside the group.',
    optionA: 'quietly repair the damage and watch for the saboteur to act again',
    optionB: 'expose your suspicion now and risk turning everyone against one another',
  },
  {
    id: 'crowd-panic',
    title: 'Panic Spreads Faster Than Truth',
    preferredTags: ['emotion', 'connection', 'illusion', 'leadership', 'communication', 'social'],
    tones: ['moral', 'chaotic'],
    problem:
      'A false warning sends a dense crowd toward a route that cannot safely hold them, while the truth is too complicated to explain quickly.',
    optionA: 'use your abilities to control the crowd without their consent',
    optionB: 'try to earn their trust while the safe window closes',
  },
  {
    id: 'hostage-standoff',
    title: 'No Clean Rescue',
    preferredTags: ['emotion', 'illusion', 'connection', 'stealth', 'combat', 'restraint'],
    tones: ['moral', 'tactical'],
    problem:
      'An armed faction holds several people and demands safe passage, but they also claim to possess proof that your allies committed a serious crime.',
    optionA: 'attempt an immediate rescue before anyone is moved',
    optionB: 'grant time for negotiation and risk letting the captors escape',
  },
  {
    id: 'invested-overload',
    title: 'Power Without Control',
    preferredTags: ['investiture', 'suppression', 'cleansing', 'knowledge', 'matter', 'amplification'],
    tones: ['tactical', 'chaotic'],
    problem:
      'An Invested device or object begins releasing power unpredictably, and shutting it down may destroy the only evidence of how it was made.',
    optionA: 'neutralize it immediately before the next surge harms someone',
    optionB: 'contain it long enough to learn who created it and why',
  },
  {
    id: 'convoy-ambush',
    title: 'The Ambush Has Two Targets',
    preferredTags: ['combat', 'flight', 'strength', 'defense', 'illusion', 'speed'],
    tones: ['tactical', 'balanced'],
    problem:
      'Attackers split their force between a civilian convoy and a guarded shipment whose loss could endanger many more people later.',
    optionA: 'protect the civilians you can see',
    optionB: 'defend the shipment whose importance they do not understand',
  },
  {
    id: 'scarce-resource',
    title: 'Not Enough to Go Around',
    preferredTags: ['resource', 'survival', 'matter', 'growth', 'healing', 'planning'],
    tones: ['moral', 'balanced'],
    problem:
      'A vital supply is running out, and the group controlling it will share only if you abandon people they consider a liability.',
    optionA: 'accept the bargain and keep the larger group moving',
    optionB: 'refuse and search for a solution that may come too late',
  },
  {
    id: 'false-accusation',
    title: 'The Evidence Points at You',
    preferredTags: ['social', 'connection', 'memory', 'detection', 'identity', 'emotion'],
    tones: ['moral', 'balanced'],
    problem:
      'Compelling evidence implicates you or your companion in a crime, and proving it false would expose a secret that protects someone innocent.',
    optionA: 'reveal the secret and clear your name',
    optionB: 'accept suspicion while trying to find another path to the truth',
  },
  {
    id: 'public-duel',
    title: 'A Challenge You Cannot Ignore',
    preferredTags: ['combat', 'foresight', 'speed', 'defense', 'strength', 'restraint'],
    tones: ['tactical', 'moral'],
    problem:
      'A dangerous opponent challenges you publicly, knowing that refusal will cost your group the trust of people you need.',
    optionA: 'accept and risk revealing the limits of your abilities',
    optionB: 'refuse and find another way to preserve the alliance',
  },
  {
    id: 'trapped-expedition',
    title: 'The Safe Route Is Gone',
    preferredTags: ['travel', 'survival', 'structure', 'breath', 'healing', 'shaping'],
    tones: ['tactical', 'balanced'],
    problem:
      'The known route out has been destroyed, leaving an injured group with one fast but dangerous path and one slow path with uncertain supplies.',
    optionA: 'take the dangerous route before conditions worsen',
    optionB: 'conserve strength and gamble on the longer path',
  },
  {
    id: 'spreading-disaster',
    title: 'Containment Is Failing',
    preferredTags: ['temperature', 'matter', 'speed', 'healing', 'structure', 'force'],
    tones: ['tactical', 'chaotic'],
    problem:
      'Fire, flood, or structural failure is spreading toward an occupied area while a smaller group remains trapped at the source.',
    optionA: 'contain the disaster before it reaches the larger population',
    optionB: 'enter the source area to rescue the people already trapped',
  },
  {
    id: 'secret-infiltration',
    title: 'The Meeting Behind Closed Doors',
    preferredTags: ['stealth', 'illusion', 'senses', 'emotion', 'identity', 'social'],
    tones: ['tactical', 'chaotic'],
    problem:
      'A private meeting may reveal who is directing recent attacks, but entering unnoticed requires impersonating or manipulating someone who trusts you.',
    optionA: 'use that trust to reach the meeting',
    optionB: 'protect the relationship and attempt a much riskier entry',
  },
  {
    id: 'rival-rescuers',
    title: 'Help With a Price',
    preferredTags: ['teamwork', 'healing', 'speed', 'strength', 'leadership', 'rescue'],
    tones: ['moral', 'balanced'],
    problem:
      'A rival group can help save everyone in danger, but they demand public credit and control of what happens afterward.',
    optionA: 'accept their terms to maximize the immediate rescue',
    optionB: 'work alone and preserve control at greater risk',
  },
  {
    id: 'realmatic-breach',
    title: 'A Door Opens the Wrong Way',
    preferredTags: ['realmatic', 'travel', 'investiture', 'connection', 'suppression', 'knowledge'],
    tones: ['chaotic', 'tactical'],
    problem:
      'A passage between places or Realms becomes unstable, separating people who cannot all be brought through before it closes.',
    optionA: 'stabilize the passage long enough for the largest group',
    optionB: 'cross immediately to reach the few stranded on the far side',
  },
  {
    id: 'compromised-leader',
    title: 'The Wrong Order',
    preferredTags: ['emotion', 'memory', 'identity', 'detection', 'connection', 'leadership'],
    tones: ['moral', 'balanced'],
    problem:
      'A respected leader gives an order that will protect the group now but cause serious harm later, and only you recognize the hidden consequence.',
    optionA: 'defy the order publicly and fracture the chain of command',
    optionB: 'obey for now while trying to limit the eventual harm',
  },
  {
    id: 'prisoner-with-truth',
    title: 'The Prisoner Knows Why',
    preferredTags: ['pursuit', 'connection', 'foresight', 'social', 'detection', 'speed'],
    tones: ['moral', 'chaotic'],
    problem:
      'Amid the emergency response, an escaped prisoner claims the authorities are concealing its real cause and offers to lead you to proof. Pursuing them would mean abandoning the people you were assigned to protect.',
    optionA: 'capture the prisoner and preserve order',
    optionB: 'help them reach the evidence before it is destroyed',
  },
];

export const complications = [
  {
    id: 'limited-reserve',
    tones: ['tactical', 'balanced'],
    text: 'Your usable Investiture or stored resource is enough for one decisive effort, not a prolonged response.',
  },
  {
    id: 'misunderstood-power',
    tones: ['moral', 'balanced'],
    text: 'Most witnesses will interpret an obvious use of your power as proof that you caused the crisis.',
  },
  {
    id: 'personal-connection',
    tones: ['moral'],
    text: 'Someone important to you is among the people most likely to suffer from the choice that helps the majority.',
  },
  {
    id: 'conflicting-order',
    tones: ['moral', 'tactical'],
    text: 'A legitimate authority has given you a direct order to choose one option and will treat refusal as betrayal.',
  },
  {
    id: 'wrong-suspect',
    tones: ['moral', 'chaotic'],
    text: 'The person everyone blames appears guilty, but one detail suggests they may be protecting the actual culprit.',
  },
  {
    id: 'secret-exposure',
    tones: ['moral', 'balanced'],
    text: 'Using your full ability will reveal a secret identity, hidden allegiance, or capability that cannot be concealed again.',
  },
  {
    id: 'injured-ally',
    tones: ['tactical', 'moral'],
    text: 'Your most capable ally is injured and can either guide you from safety or accompany you at serious personal risk.',
  },
  {
    id: 'conditions-worsen',
    tones: ['chaotic', 'tactical'],
    text: 'The environment is deteriorating faster than expected, and every delay permanently removes an option.',
  },
  {
    id: 'rival-bargain',
    tones: ['moral', 'chaotic'],
    text: 'A rival offers exactly the help you need, but only in exchange for a favor whose consequences they refuse to explain.',
  },
  {
    id: 'hidden-information',
    tones: ['moral', 'balanced'],
    text: 'One member of the group knows why this is happening but believes revealing the truth would make the outcome worse.',
  },
  {
    id: 'collateral-risk',
    tones: ['tactical', 'moral'],
    text: 'The fastest use of your power will solve the immediate problem while causing damage that vulnerable people will inherit.',
  },
  {
    id: 'countdown',
    tones: ['chaotic', 'tactical'],
    text: 'You have only minutes before travel, weather, or an approaching force makes the decision irreversible.',
  },
];

export const stakes = [
  'The lives of people who do not understand Investiture depend on the outcome.',
  'Failure will destroy the community\'s trust in anyone with powers like yours.',
  'The only surviving evidence of a much larger threat may be lost.',
  'A fragile peace between rival groups will collapse if either side feels betrayed.',
  'This is the only safe route available to people arriving later.',
  'Your reputation and ability to help openly in the future are at risk.',
  'A scarce resource needed for the coming weeks may be consumed in a single night.',
  'An ally who once saved your life will bear the cost of the most practical choice.',
  'Choosing incorrectly will leave the same danger free to strike somewhere else.',
  'The apparent enemy is also protecting innocent people who cannot escape alone.',
];

export const relationships = [
  'You are longtime partners with opposite instincts about when power should be used.',
  'You are strangers forced to cooperate because neither ability can solve the problem alone.',
  'You are rivals operating under a temporary truce that neither side fully trusts.',
  'One of you is the other\'s mentor, but the student has recognized something the mentor missed.',
  'You are family members who agree on the goal and disagree sharply about the acceptable cost.',
  'One of you represents the authorities; the other is the primary suspect in the crisis.',
  'You lead competing rescue efforts and must decide who takes command.',
  'One of you owes the other a serious debt that can be called in during this decision.',
];

const abilityTags = {
  allomancy: {
    Iron: ['metal', 'force', 'movement', 'detection'],
    Steel: ['metal', 'force', 'movement', 'speed', 'pursuit'],
    Tin: ['senses', 'detection', 'tracking'],
    Pewter: ['strength', 'combat', 'endurance', 'rescue'],
    Zinc: ['emotion', 'social', 'leadership'],
    Brass: ['emotion', 'social', 'restraint'],
    Copper: ['stealth', 'concealment', 'defense'],
    Bronze: ['detection', 'tracking', 'investiture'],
    Aluminum: ['cleansing', 'suppression', 'sacrifice'],
    Duralumin: ['amplification', 'force', 'resource'],
    Chromium: ['suppression', 'combat', 'restraint'],
    Nicrosil: ['amplification', 'teamwork', 'investiture'],
    Gold: ['identity', 'memory', 'introspection'],
    Electrum: ['foresight', 'defense', 'combat'],
    Cadmium: ['time', 'containment', 'defense'],
    Bendalloy: ['time', 'speed', 'rescue'],
    Atium: ['foresight', 'combat', 'detection'],
  },
  feruchemy: {
    Iron: ['force', 'mass', 'defense', 'structure'],
    Steel: ['speed', 'pursuit', 'rescue'],
    Tin: ['senses', 'detection', 'tracking'],
    Pewter: ['strength', 'combat', 'rescue'],
    Zinc: ['intellect', 'planning', 'knowledge'],
    Brass: ['temperature', 'survival', 'resource'],
    Copper: ['memory', 'knowledge', 'detection'],
    Bronze: ['endurance', 'survival', 'resource'],
    Aluminum: ['identity', 'realmatic', 'spiritual'],
    Duralumin: ['connection', 'social', 'communication'],
    Chromium: ['foresight', 'uncertainty', 'planning'],
    Nicrosil: ['investiture', 'amplification', 'resource'],
    Gold: ['healing', 'rescue', 'endurance'],
    Electrum: ['endurance', 'leadership', 'resistance'],
    Cadmium: ['breath', 'survival', 'rescue'],
    Bendalloy: ['resource', 'survival', 'endurance'],
    Atium: ['identity', 'disguise', 'resource'],
  },
  surgebinding: {
    Adhesion: ['connection', 'restraint', 'structure', 'leadership'],
    Gravitation: ['flight', 'movement', 'force', 'rescue'],
    Division: ['combat', 'destruction', 'matter'],
    Abrasion: ['speed', 'movement', 'pursuit'],
    Progression: ['healing', 'growth', 'rescue'],
    Illumination: ['illusion', 'stealth', 'communication'],
    Transformation: ['matter', 'survival', 'resource'],
    Transportation: ['travel', 'realmatic', 'escape'],
    Cohesion: ['shaping', 'structure', 'matter'],
    Tension: ['structure', 'defense', 'shaping'],
  },
};

export function getAbilityTags(card) {
  return abilityTags[card.system]?.[card.name] || [];
}

export const scenarioContentCounts = {
  settings: settings.length,
  challenges: challenges.length,
  complications: complications.length,
  stakes: stakes.length,
  relationships: relationships.length,
};
